import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AuthService } from './AuthService';
import { IThemeColor } from '../theme/IThemeColor';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { ISignInTrackingFrom } from './ISignInTrackingFrom';

export const CreateAccountButton: React.FC<{color?: IThemeColor, trackingFrom: ISignInTrackingFrom }> = ({ color, trackingFrom }) => {
    const mixpanel = useInstance(MixPanelEventEmitter);
    const authService = useInstance(AuthService);

    const onClick = () => {
        mixpanel.track('Sign In Initiated', () => ({ From: trackingFrom }));
        authService.login();
    };

    return (
        <IonButton
            data-type="sign-in-or-create-account"
            fill="outline"
            expand="block"
            color={color}
            onClick={onClick}
        >
            Sign In or Create Account
        </IonButton>
    );
};
